import { HttpParams } from '@angular/common/http';
import { Renderer2 } from '@angular/core';
import i18n_name from '../../../assets/i18n/bank-name.json';
import i18n_channelName from '../../../assets/i18n/channel-name.json';

export * from './string';
export * from './calendar';

export function toHttpParams(object: { [key: string]: any }) {
  let params: HttpParams = new HttpParams();
  Object.keys(object).forEach(key => {
    const value = object[key];
    if (value !== undefined) {
      if (value instanceof Array) {
        value.forEach(v => {
          params = params.append(key, v);
        });
      } else {
        params = params.append(key, value);
      }
    }
  });
  return params;
}

export function getBankName(value: string): string {
  return i18n_name.hasOwnProperty(value)
    ? localStorage.NG_TRANSLATE_LANG_KEY === 'en'
      ? value
      : i18n_name[value]
    : value;
}

export function getChannelName(value: string): string {
  return i18n_channelName.hasOwnProperty(value) ? i18n_channelName[value] : value;
}

export function getHasChannelCode(value: string): string {
  return i18n_channelName.hasOwnProperty(value) ? value : null;
}

/**对象深度copy**/
export function $copy(obj: any) {
  return JSON.parse(JSON.stringify(obj));
}

/**对象非空过滤**/
export function Obj2Filter(Obj: any) {
  let NewObj = JSON.parse(JSON.stringify(Obj)),
    item,
    OBJ = {};
  for (let p in NewObj) {
    item = JSON.stringify(NewObj[p]);
    if ((item.length > 2 && item !== '{}' && item !== '[]') || !!NewObj[p]) {
      OBJ[p] = NewObj[p];
    }
  }
  return OBJ;
}

/**时间格式化，this.Format(this.TempList[i].createTime,'yyyy-MM-dd hh:mm:ss**/
export function formatDate(date, fmt) {
  if (!date) {
    return '';
  }
  if (!fmt) {
    fmt = 'yyyy-MM-dd';
  }
  const o = {
    'M+': new Date(date).getMonth() + 1, //月份
    'd+': new Date(date).getDate(), //日
    'h+': new Date(date).getHours(), //小时
    'm+': new Date(date).getMinutes(), //分
    's+': new Date(date).getSeconds(), //秒
    'q+': Math.floor((new Date(date).getMonth() + 3) / 3), //季度
    S: new Date(date).getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (new Date(date).getFullYear() + '').substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  return fmt;
}

/**时间格式化V2, currentType:当前的时间类型，fmt：需要转换的时间类型**/
export function FDateV2(date, dateType: string, fmt: string | Date) {
  if (!date) {
    return '';
  }
  if (!dateType) {
    return '';
  }
  if (!fmt) {
    fmt = 'yyyy/MM/dd';
  }
  date = date.toString();
  dateType = dateType.toString();
  if (dateType === 'yyyymmdd' || dateType === 'yyyyMMdd') {
    date = date.substr(0, 4) + '/' + date.substr(4, 2) + '/' + date.substr(6);
    if (typeof fmt === 'string') {
      return formatDate(date, fmt);
    }
    if (typeof fmt === 'object') {
      return new Date(date);
    }
  }
}

/**Money格式化**/
export function formatMoney(num: any, calc?: number, scale?: number) {
  /**1000000, 100   => 10,000.00**/
  if (!num) {
    num = 0;
  }
  let NewNum = '',
    minus = false,
    total,
    t,
    left = 0,
    last = '.00';
  if (!num) {
    NewNum = '';
  }

  num = num.toString().replace(/,/g, '');
  if (num.indexOf('-') === 0) {
    minus = true;
    num = num.substr(1);
  }
  num = Number(num);
  if (!calc) {
    calc = 1;
  }
  if (!scale && scale !== 0) {
    scale = 2;
  }
  num = (num / calc).toFixed(scale).toString();
  if (num.split('.').length > 1) {
    last = '.' + num.split('.')[1];
    if (last.length === 2) {
      last += '0';
    }
    num = num.split('.')[0];
  }
  total = num.length;
  t = Math.floor(total / 3);
  if (t === 0) {
    NewNum = num + last;
  } else {
    left = total - t * 3;
    if (left > 0) {
      NewNum += num.substr(0, left) + ',';
      for (let i = 0; i < t; i++) {
        NewNum += num.substr(i * 3 + left, 3);
        if (i < t - 1) {
          NewNum += ',';
        }
      }
    } else {
      for (let i = 0; i < t; i++) {
        NewNum += num.substr(i * 3, 3);
        if (i < t - 1) {
          NewNum += ',';
        }
      }
    }
    NewNum += scale === 0 ? '' : last;
  }
  return minus ? '-' + NewNum : NewNum;
}

/**下载blob文件**/
// export function $downLoadBlob(blob: object, fileName: string) {
//   if (window.navigator && window.navigator.msSaveOrOpenBlob) {
//     window.navigator.msSaveBlob(blob, fileName);
//   } else {
//     let linkEL = document.createElement('a');
//     linkEL.download = fileName;
//     linkEL.style.display = 'none';
//     linkEL.href = window.URL.createObjectURL(blob);
//     document.body.appendChild(linkEL);
//     linkEL.click();
//     window.URL.revokeObjectURL(linkEL.href);
//     document.body.removeChild(linkEL);
//   }
// }

export function resetHeightInIframe(renderer: Renderer2) {
  const scrollDom = window.parent.document || document;
  const iframeSelf = scrollDom.getElementsByTagName('iframe')[0];
  if (iframeSelf) {
    renderer.setAttribute(iframeSelf, 'height', '0');
  }
  window.dispatchEvent(new Event('resize'));
}

export function toFloat(num: number | string, length?: number) {
  let FN = Number.NaN;
  if (typeof length === 'undefined' || !length) length = 2;
  if (typeof num === 'string') {
    FN = parseFloat(num.replace(/,/g, ''));
  } else if (typeof num === 'number') {
    FN = num;
  }
  let n = Math.pow(10, length);
  return Math.round(FN * n) / n;
}

/**money递进式单位格式化**/
export function MPUF(num: any = 0, scale: number = 2) {
  let calc,
    NewNum,
    n1,
    n2,
    unit = '';
  calc = Math.pow(10, scale);
  num = num.toString().replace(/,/g, '');
  (NewNum = num.split('.')), (n1 = NewNum[0]), (n2 = NewNum[1] || '00'), (unit = '');
  if (n1.length > 0 && n1.length < 5) {
    NewNum = n1 + '.' + n2;
  }
  if (n1.length >= 5 && n1.length < 9) {
    unit = $localize`万`;
    NewNum = Number((num / 10000).toFixed(num.length));
  }
  if (n1.length >= 9 && n1.length < 13) {
    unit = $localize`亿`;
    NewNum = Number((num / 100000000).toFixed(num.length));
  }
  if (n1.length >= 13) {
    unit = $localize`万亿`;
    NewNum = Number((num / 1000000000000).toFixed(num.length));
  }
  NewNum = formatMoney(Math.round(NewNum * calc) / calc.toFixed(scale), 1, scale) + unit;
  return NewNum;
}

export function $indexOfObject(arrayObject, findObject) {
  let index = 0,
    object;
  for (; index < arrayObject.length; index++) {
    object = arrayObject[index];
    let keys = Object.keys(findObject);
    let j = 0;
    let equalLength = 0;
    for (j = 0; j < keys.length; j++) {
      let key = keys[j];
      if (object[key] === findObject[key]) {
        equalLength++;
      } else {
        break;
      }
    }
    if (equalLength === keys.length) {
      return index;
    }
  }
  return -1;
}

/**对象转string**/
export function Obj2String(Obj: any) {
  let string = '',
    t = 0,
    NewObj = JSON.parse(JSON.stringify(Obj));
  for (let p in NewObj) {
    if (JSON.stringify(NewObj[p]) === '0' || JSON.stringify(NewObj[p]) === 'false' || !!NewObj[p]) {
      t++;
      if (t === 1) {
        string += '?';
      } else {
        string += '&';
      }
      string += p + '=' + NewObj[p];
    }
  }
  return string;
}

export function MoneyUnitText(num: number, fixed?: number) {
  const result = MoneyUnit(num, fixed);
  return result.money + result.unit;
}

/*
 * 统一金额大数字显示规范
 * 中文显示 ['', '万', '亿', '万亿'] dividend-分割率 10000
 * K-千、 million-百万、 billion-十亿、Trillions-万亿
 * 英文显示 ['', 'K', 'M', 'T'] dividend-分割率 1000
 * translateLangKey: cn 中文、 en 英文
 */

export function MoneyUnit(num: number, fixed?: number) {
  // onst cnMoneyUnits = ['NONE', 'CN_W', 'CN_Y', 'Tri']; // ['', '万', '亿', '万亿']
  // const enMoneyUnits = ['NONE', 'K', 'MM', 'BN', 'Tri']; // ['', '千', '百万', '十亿'，'万亿']
  const cnMoneyUnits = ['', '万', '亿', '万亿']; // ['', '万', '亿', '万亿']
  const enMoneyUnits = ['NONE', 'K', 'MM', 'BN', 'Tri']; // ['', '千', '百万', '十亿'，'万亿']
  // var translateLangKey = c4cf.getTranslateLangKey();
  const translateLangKey = 'cn'; // 这里之后要改为动态获取当前系统的语言

  let moneyUnits = [];
  let dividend = 0;

  switch (translateLangKey) {
    case 'cn':
      dividend = 10000;
      moneyUnits = cnMoneyUnits;
      break;
    // case 'en':  // 默认先去掉英文环境判断，等translateLangKey动态获取后，再去掉这里的注释
    //   dividend = 1000;
    //   moneyUnits = enMoneyUnits;
    //   break;

    default:
      // 默认英文
      dividend = 1000;
      moneyUnits = enMoneyUnits;
  }

  const result = unitConvert(num, dividend, moneyUnits, fixed);
  return result;
}

/*货币转换函数
 * @params num: 金额、 dividend: 分割率、 fixed: 保留小数位、 moneyUnits: 货币单位集合
 * @return
 */
function unitConvert(num: number, dividend: number, moneyUnits: string[], fixed?: number) {
  const numSymbol = num < 0 ? '-' : '';
  num = Math.abs(num);
  const moneyUnitsLen = moneyUnits.length;
  let curentNum = num; // 转换数字
  let curentUnit = moneyUnits[0]; // 转换单位
  fixed = fixed || 2; // 默认fixed = 2

  for (let i = 0; i < moneyUnitsLen; i++) {
    curentUnit = moneyUnits[i];
    if (strNumSize(curentNum) < dividend.toString().length) {
      break;
    }
    curentNum = curentNum / dividend;
  }

  const value = curentNum.toFixed(fixed);
  const money = formatMoney(curentNum, fixed);
  const m = {
    value: parseFloat(numSymbol + value),
    unit: curentUnit,
    num: parseFloat(numSymbol + num),
    money: numSymbol + money
  };

  return m;
}

// 切分数字字符串
function strNumSize(tempNum: number) {
  const stringNum = tempNum.toString();
  const index = stringNum.indexOf('.');
  let newNum = stringNum;
  if (index !== -1) {
    newNum = stringNum.substring(0, index);
  }

  return newNum.length;
}

/**url重写**/
export function resetUrl() {
  let url = window.location.href;
  /**
  let s1 = url.indexOf('index.html?t=');
  let s2 = url.indexOf('#!/');
  window.history.pushState(
    { time: url.substr(s1, s2 - s1).replace('index.html?t=', '') },
    '',
    url.substr(0, s1) + url.substr(s2)
  );**/
  let urls = url.split('/');
  for (let i = 0; i < urls.length; i++) {
    if (urls[i].includes('index.html?t=')) {
      urls[i] = '#!';
    }
  }
  window.history.pushState({ time: new Date().getTime() }, '', urls.join('/'));
}

/**根据文件后缀，判断文件类型**/
export function getFileType(file) {
  let fileList = {
    pdf: ['pdf'],
    ofd: ['ofd'],
    image: ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'tif', 'tiff'],
    word: ['doc', 'docx', 'dot', 'dotx', 'rtf', 'docm', 'dotm'],
    excel: ['xls', 'xlsx', 'xlt', 'et', 'ett', 'xlsm', 'csv', 'xltx', 'xltm'],
    ppt: ['ppt', 'pptx', 'pot', 'pps', 'pptm', 'potx', 'potm', 'ppsx', 'ppsm']
  };
  let t = file.split('.').length;
  let name = file.split('.')[t - 1].toLowerCase();
  let type = '';
  for (let x in fileList) {
    if (fileList[x].includes(name)) {
      type = x;
    }
  }
  return type;
}

export function median(arr: number[]) {
  const concat = arr.sort((a, b) => a - b);
  const length = concat.length;
  if (length % 2 == 1) {
    // 如果长度是奇数
    return concat[length / 2 - 0.5];
  } else {
    // 如果长度是偶数
    return (concat[length / 2] + concat[length / 2 - 1]) / 2;
  }
}

export function isISO88591(str) {
  return [...str].every(char => char.charCodeAt(0) <= 0xff);
}

export function decodeISO88591(str: string) {
  if (!isISO88591(str)) return str;
  const bytes = [];
  for (let i = 0; i < str.length; i++) {
    bytes.push(str.charCodeAt(i));
  }
  const decodedStr = new TextDecoder('utf-8').decode(new Uint8Array(bytes));
  return decodedStr;
}
